String.prototype.toClass = function() {
  return '.'.concat(this);
};

String.prototype.toId = function() {
  return '#'.concat(this);
};
